import { lazy } from 'react';

const ReceivedIntegrativeTransformerTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/integrative/consult/received-transfer-info',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default ReceivedIntegrativeTransformerTransferConfig;


